import { css } from "@compiled/react";

import { media } from "@atlaskit/primitives/responsive";

import { Picture } from "@/components/wpl/image/src/image";
import {
    FeatureInfo,
    FeatureInfoProps
} from "@/patterns/feature-info/feature-info";

const imageStyle = css({
    paddingInlineStart: 16,
    paddingInlineEnd: 16,
    [media.below.sm]: {
        paddingInlineStart: 0,
        paddingInlineEnd: 0
    }
});

const imageSizing = css({
    display: "flex",
    [media.below.lg]: {
        height: "auto",
        width: "100%",
        maxWidth: "100vw",
        margin: "auto",
        aspectRatio: "auto"
    }
});

const iconSpacingOverride = css({
    // override the icon and text spacing
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    "li": {
        gap: "8px",
        [media.below.lg]: {
            marginInlineEnd: "0px"
        }
    },
    // add gap between each description item
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    "ul": {
        gap: "8px"
    },

    // responsive image
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    "img": {
        [media.below.lg]: {
            maxWidth: "100%",
            height: "auto"
        }
    },
    // cta button padding override
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    "div > div:last-child > div > div:last-child": {
        [media.below.lg]: {
            paddingInlineStart: "0px",
            paddingInlineEnd: "0px"
        }
    }
});

export const ContentTypeImage = ({
    active,
    imageSrc,
    imageAlt,
    ...props
}: FeatureInfoProps & {
    active?: boolean;
    imageSrc: string;
    imageAlt: string;
}) => {
    const FeatureInfoImage = (
        <div css={[imageStyle]}>
            <div css={imageSizing}>
                <Picture
                    image={{
                        src: imageSrc,
                        alt: imageAlt,
                        width: 736,
                        height: 433
                    }}
                />
            </div>
        </div>
    );

    return (
        <div css={iconSpacingOverride} className="tab-content-image-container">
            <FeatureInfo {...props} reverseLayout>
                {FeatureInfoImage}
            </FeatureInfo>
        </div>
    );
};
